export default __webpack_public_path__ + "static/media/bluebulbs.b294d535.jpg";